// extracted by mini-css-extract-plugin
export var actionButton = "_kj-0";
export var actionMenuContainer = "_kj-i";
export var bubble = "_kj-2";
export var bubbleActionMenu = "_kj-j";
export var bubbleContext = "_kj-6";
export var bubbleItems = "_kj-7";
export var customer = "_kj-3";
export var divider = "_kj-8";
export var fileList = "_kj-9";
export var hiddenComment = "_kj-o";
export var infoAbove = "_kj-a";
export var internal = "_kj-4";
export var lightActionButton = "_kj-1";
export var link = "_kj-b";
export var merchant = "_kj-5";
export var message = "_kj-c";
export var profilePicture = "_kj-e";
export var quillToolbarContainer = "_kj-f";
export var senderDate = "_kj-g";
export var senderDateCustomer = "_kj-h";
export var senderName = "_kj-d";
export var time = "_kj-k";
export var uploadedImage = "_kj-l";
export var username = "_kj-m";
export var xsmall = "_kj-n";